<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Productivity') }}</h4>
        </div>
        <div>
          <div class="form-inline">
            <div class="form-group mr-2">
              <range-date-filter
                :value="rangeDate"
                @input="(v) => { setFilters({created_at: v}) }"
                style="min-width: 210px"> 
                </range-date-filter>
            </div>
            <button
              class="btn btn-light"
              @click="exportReport">
              {{ $t('Export xlsx') }}
              </button>
          </div>
        </div>
      </div>
    </div>

    <div class="vflex-row-1">

      <filterfy
        :models="filtersMap"
        :initFilters="filters"
        @changed="setFilters">

        <Paginaty
          :total="grid.total"
          :pages="grid.pages"
          :page="grid.page"
          :creating="creating"
          :loading="loading"
          @changePage="setPage">
          
          <template slot="content">
            <!-- <div class="p-3" style="width: 100%; overflow: hidden;">
              <highcharts
                :options="chartOptions">
                </highcharts>
            </div> -->
            <div> <!--  style="height: 100%; overflow-x: scroll;" -->
              <table class="table table-bordered">
                <thead class="thead-fixed">
                  <tr>
                    <th-sort
                      field="name"
                      :value="sort"
                      @input="setSort">Recrutador</th-sort>
                    <th-sort
                      field="total_notes"
                      :value="sort"
                      @input="setSort">{{ $t('Notes') }}</th-sort>
                    <th-sort
                      field="total_events"
                      :value="sort"
                      @input="setSort">{{ $t('Schedules') }}</th-sort>
                    <th-sort
                      field="total_evaluations"
                      :value="sort"
                      @input="setSort">{{ $t('Evaluations') }}</th-sort>
                    <th-sort
                      field="total_emails"
                      :value="sort"
                      @input="setSort">{{ $t('Emails') }}</th-sort>
                    <th-sort
                      field="total_moves"
                      :value="sort"
                      @input="setSort">Movimentações</th-sort>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in grid.docs">
                    <th class="text-truncate">{{ item.name }}</th>
                    <td class="text-truncate">{{ item.total_notes }}</td>
                    <td class="text-truncate">{{ item.total_events }}</td>
                    <td class="text-truncate">{{ item.total_evaluations }}</td>
                    <td class="text-truncate">{{ item.total_emails }}</td>
                    <td class="text-truncate">{{ item.total_moves }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>

          <template slot="noresults">
            {{ $t('There are no items') }}
          </template>

        </Paginaty>

      </filterfy>
    </div>
  </div>

</template>

<script>
import {Chart} from 'highcharts-vue'
import Filterfy from '@/components/Filterfy/Filterfy'
import ThSort from '@/components/Parts/ThSort'
import Paginaty from '@/components/Paginaty/Paginaty'
import RangeDateFilter from './RangeDateFilter'
import BlobDownload from '@/utils/BlobDownload'
import FilterfyToQuery from '@/utils/FilterfyToQuery'
import moment from 'moment'

export default {
  name: 'ReportProdutivity',
  components: {
    highcharts: Chart,
    Filterfy,
    ThSort,
    Paginaty,
    RangeDateFilter
  },
  data () {
    return {
      creating: true,
      loading: true,
      filtersMap: [
        /* {
          'type': 'list',
          'label': this.$t('Company'),
          'target': 'company_id',
          'resource': 'companies'
        },
        {
          'type': 'list',
          'label': this.$t('Department'),
          'target': 'departament_id',
          'resource': 'departaments'
        } */
      ],
      grid: false
    }
  },
  computed: {
    filters () {
      return this.$route.query
    },
    sort () {
      return this.$route.query.sort || 'name'
    },
    rangeDate () {
      const defaultDate = `d|${moment().subtract(30, 'days').toISOString()}|${moment().toISOString()}`
      return this.$route.query.created_at === undefined ? defaultDate : this.$route.query.created_at
    },
    chartOptions () {
      if (this.grid) {
        return {
          chart: {
            type: 'column'
          },
          lang: {
            noData: this.$t('No data to display')
          },
          title: {
            text: 'Produtividade'
          },
          xAxis: {
            categories: this.grid.docs.map(v => v.name)
          },
          yAxis: {
            min: 0,
            title: {
              text: 'Atividades'
            }
          },
          plotOptions: {
            column: {
              stacking: 'normal',
              dataLabels: {
                enabled: false
              }
            }
          },
          series: [
            {
              name: 'Notas',
              data: this.grid.docs.map(v => v.total_notes)
            },
            {
              name: 'Agendamentos',
              data: this.grid.docs.map(v => v.total_events)
            },
            {
              name: 'Avaliações',
              data: this.grid.docs.map(v => v.total_evaluations)
            },
            {
              name: 'E-mails',
              data: this.grid.docs.map(v => v.total_emails)
            },
            {
              name: 'Movimentações',
              data: this.grid.docs.map(v => v.total_moves)
            }
          ] /* [{
              name: 'John',
              data: [5, 3, 4, 7, 2]
          }, {
              name: 'Jane',
              data: [2, 2, 3, 2, 1]
          }, {
              name: 'Joe',
              data: [3, 4, 4, 2, 5]
          }] */
        }
      }
      return null
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.loading = true

      const params = {
        ...FilterfyToQuery(this.filters, this.filtersMap),
        created_at: this.rangeDate,
        page: this.$route.query.page || 1,
        sort: this.sort,
        limit: this.$default.limit
      }

      this.axios
      .get('/accounts/' + this.$store.getters.getAccount._id + '/reports/productivity', {params: params})
      .then((response) => {
        this.grid = response.data
        this.loading = this.creating = false
      })
    },
    /*
    setFilters
    */
    setFilters (filters) {
      this.$changeUrlParam(filters)
      this.setPage(1)
    },
    setSort (sort) {
      this.$changeUrlParam({sort: sort})
      this.setPage(1)
    },
    setPage (page) {
      this.$changeUrlParam({page: page})
      this.loadData()
    },
    exportReport () {
      let params = Object.assign(this.filters, {
        sort: this.sort
      })

      this.axios
      .get('/accounts/' + this.$store.getters.getAccount._id + '/reports/productivity/export', {params: params, responseType: 'blob', timeout: 30000})
      .then((response) => {
        BlobDownload(response)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Report/ReportProductivity.vue